__turbopack_context__.v({
  "annotationFrame": "HudAnnotations-module__hhLOTa__annotationFrame",
  "annotationLabel": "HudAnnotations-module__hhLOTa__annotationLabel",
  "annotationPrefix": "HudAnnotations-module__hhLOTa__annotationPrefix",
  "cornerDot": "HudAnnotations-module__hhLOTa__cornerDot",
  "hudAnnotationWrapper": "HudAnnotations-module__hhLOTa__hudAnnotationWrapper",
});
